import suggestionsAPI from '../../../api/suggestions'

const mapOrder = (order) => {
  switch (order) {
  case 'user':
    return 'name'
  case 'sent':
    return 'created_at'
  default:
    return 'name'
  }
}

export default {
  async index({commit, state, rootState}, view) {
    const tenantID = rootState.tenants.current.id
    const meta = state.views[view].meta
    const params = {tenantID}

    if (typeof(meta.active) !== 'undefined' && meta.active !== null) {
      params.active = meta.active
    }
    if (typeof(meta.order) !== 'undefined' && meta.order !== null) {
      params.order = mapOrder(meta.order)
    }
    if (typeof(meta.desc) !== 'undefined' && meta.desc !== null) {
      params.desc = meta.desc
    }

    // don't set page if search is set
    if (typeof(meta.search) !== 'undefined' && meta.search !== null) {
      params.search = meta.search
    } else if (typeof(meta.current_page) !== 'undefined' && meta.current_page !== null) {
      params.page = meta.current_page
    }

    commit('setFetchingForView', {view, value: true})

    const resp = await suggestionsAPI.index(params)
    const index = resp.data.data
    const updatedMeta = resp.data.meta

    commit('setView', {view, index, meta: updatedMeta})
    commit('setFetchingForView', {view, value: false})
  },

  async show({commit, rootState}, {id}) {
    const tenantID = rootState.tenants.current.id
    const resp = await suggestionsAPI.show({tenantID, suggestionID: id})
    const suggestion = resp.data.data
    commit('setCurrent', suggestion)
  },

  async update({commit, state, rootState, dispatch}, {id, data}) {
    const tenantID = rootState.tenants.current.id

    commit('setFetchingForView', {view: state._defaultView, value: true})
    commit('setFetchingForView', {view: state._readView, value: true})
    await suggestionsAPI.update({tenantID, suggestionID: id, data})
    dispatch('index', state._defaultView)
    dispatch('index', state._readView)
  },

  async destroy({commit, state, rootState, dispatch}, id) {
    const tenantID = rootState.tenants.current.id

    commit('setFetchingForView', {view: state._defaultView, value: true})
    commit('setFetchingForView', {view: state._readView, value: true})
    await suggestionsAPI.destroy({tenantID, suggestionID: id})
    dispatch('index', state._defaultView)
    dispatch('index', state._readView)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/suggestions/actions.js